export default "__VITE_ASSET__BNezjygv__"